var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInj(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.06
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_884_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.78878 7.97324C6.93253 7.79499 7.08203 7.62249 7.23153 7.44999C7.23728 7.44424 7.25453 7.43849 7.26028 7.43274C7.27178 7.41549 7.29478 7.40399 7.31203 7.38674L7.32353 7.36949C7.42703 7.27174 7.54203 7.16824 7.66853 7.07049C8.12853 6.72549 8.60003 6.46099 9.10028 6.28274C10.7103 5.71924 12.4985 6.06424 13.9015 7.39249C15.8623 9.22674 15.684 12.188 14.12 14.1545C12.142 17.087 8.74953 21.1752 13.4473 24.838C14.2925 25.4992 14.9193 26.0397 17.5815 26.8102C15.8393 27.1322 14.2235 27.0287 12.4295 26.5745C11.1588 25.8557 9.15778 24.3205 8.47928 22.2447C7.45003 19.0995 10.2905 14.3902 11.659 12.579C13.5393 10.072 10.4975 7.35799 8.24928 10.3882C7.08778 11.9695 5.03503 16.4372 5.74803 19.755C6.16203 21.6352 6.71978 23.0037 8.92203 24.8897C8.51378 24.6482 8.11703 24.378 7.73178 24.0675C2.62003 19.3007 3.21228 11.9292 6.78878 7.97324Z",
    fill: "url(#paint0_linear_884_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2113 23.0268C24.0675 23.205 23.918 23.3775 23.7685 23.55C23.7628 23.5558 23.7455 23.5615 23.7398 23.5673C23.7283 23.5845 23.7053 23.596 23.688 23.6133L23.6765 23.6305C23.573 23.7283 23.458 23.8318 23.3315 23.9238C22.8715 24.2688 22.4 24.5333 21.8998 24.7115C20.2898 25.275 18.5015 24.93 17.0985 23.6018C15.1378 21.7675 15.316 18.8063 16.88 16.8398C18.858 13.9073 22.2505 9.819 17.5528 6.15625C16.7075 5.495 16.0808 4.9545 13.4185 4.184C15.1608 3.862 16.7765 3.9655 18.5705 4.41975C19.8413 5.1385 21.8423 6.67375 22.5208 8.7495C23.55 11.8948 20.7095 16.604 19.341 18.4153C17.4608 20.9223 20.5025 23.6363 22.7508 20.606C23.9238 19.0248 25.9765 14.557 25.2635 11.2393C24.8495 9.359 24.2918 7.9905 22.0895 6.1045C22.4978 6.346 22.8945 6.61625 23.2798 6.92675C28.38 11.6993 27.7878 19.0708 24.2113 23.0268Z",
    fill: "url(#paint1_linear_884_2)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_884_2",
    x1: 4.00003,
    y1: 16.5141,
    x2: 27,
    y2: 16.5141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932292,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F2FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_884_2",
    x1: 4.00002,
    y1: 14.4859,
    x2: 27,
    y2: 14.4859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442461,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_884_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInj);
export default __webpack_public_path__ + "static/media/INJ.8684bc424377564862654316b82110dd.svg";
export { ForwardRef as ReactComponent };